import { FixtureDetails } from './../models/connected-devices/fixture-details.model';
import { Magneto } from './../models/magneto.model';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Toro } from '../common/enumerations';
import { AddEditLpcuApiModel } from '../models/add-lpcu-api.model';
import { LpcuDetails } from '../models/connected-devices/lpcu-details.model';
import { DependentDevice, DevicesResponse } from '../models/dependent-device.model';
import { DependentDeviceApiService } from '../services/dependent-device-api.service';

@Injectable()
export class DependentDeviceManagerService {
    private _lpcusDict: { [gatewayId: number]: DependentDevice[] } = {};

    constructor(private dependentDeviceApiService: DependentDeviceApiService) {
    }

    public placeDependentDeviceInDiscoveryMode(gatewayId: number, deviceType = Toro.DeviceType.LPCU): Observable<any> {
        return this.dependentDeviceApiService.placeDependentDeviceInDiscoveryMode(gatewayId, deviceType);
    }

    public cancelDependentDeviceDiscoveryMode(gatewayId: number): Observable<any> {
        return this.dependentDeviceApiService.cancelDependentDeviceDiscoveryMode(gatewayId);
    }

    public updateLpcusDict(gatewayId: number, dependentDevice: DependentDevice) {
        const lpcuToUpdateIndex = this._lpcusDict[gatewayId].findIndex(device => device.Id === dependentDevice.Id);
        this._lpcusDict[gatewayId][lpcuToUpdateIndex] = dependentDevice;
    }

    public getDevices(gatewayId: number, withoutPagination: boolean = false, pageNumber: number = 1, pageSize: number = 20, cached: boolean = false): Observable<DevicesResponse> {
        // if (cached && this._lpcusDict[gatewayId]) {
        //     return of(this._lpcusDict[gatewayId]);
        // }

        return this.dependentDeviceApiService.getLpcus(gatewayId, withoutPagination, pageNumber, pageSize)
            .pipe(
                tap((response: DevicesResponse) => {
                    this._lpcusDict[gatewayId] = response.Devices;
                })
            );
    }

    public getDeviceDetails(deviceId: number): Observable<LpcuDetails> {
        return this.dependentDeviceApiService.getDeviceDetails(deviceId);
    }

    public getFixtureDetails(deviceId: number, theme: { themeOrdinalPosition: number, themeId: number }): Observable<FixtureDetails> {
        return this.dependentDeviceApiService.getFixtureDetails(deviceId, theme);
    }

    public scanDevice(deviceId: number, isMagneto: boolean): Observable<any> {
        return this.dependentDeviceApiService.scanDevice(deviceId, isMagneto);
    }

    public previewDevice(deviceId, previewDetails): Observable<any> {
        return this.dependentDeviceApiService.previewDevice(deviceId, previewDetails)
    }
    public addLpcu(gatewayId: number, addLPCUApiModel: AddEditLpcuApiModel): Observable<any> {
        return this.dependentDeviceApiService.addLpcu(gatewayId, addLPCUApiModel);
    }

    public updateLpcu(deviceId: number, addLPCUApiModel: AddEditLpcuApiModel): Observable<any> {
        return this.dependentDeviceApiService.updateLpcu(deviceId, addLPCUApiModel);
    }

    public addMagneto(gatewayId: number, magneto: Magneto): Observable<any> {
        return this.dependentDeviceApiService.addMagneto(gatewayId, magneto);
    }

    public updateMagneto(deviceId: number, magneto: Magneto): Observable<any> {
        return this.dependentDeviceApiService.updateMagneto(deviceId, magneto);
    }

    public deleteDependentDevice(deviceId: number): Observable<any> {
        return this.dependentDeviceApiService.deleteDependentDevice(deviceId);
    }
}
